import { useEffect, useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { Menu, X, ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Sheet, SheetContent, SheetTrigger, SheetTitle } from "@/components/ui/sheet";
import logoColor from "@/assets/logo-color.png";
import { track } from "@/lib/forms";

const NAV = [
  { label: "Services", to: "/services" },
  { label: "Use Cases", to: "/use-cases" },
  { label: "Alfred", to: "/alfred" },
  { label: "Apps", to: "/#apps" },
  { label: "Events", to: "/events" },
  { label: "Contact", to: "/contact" },
];

export default function Header() {
  const [open, setOpen] = useState(false);
  const loc = useLocation();
  useEffect(() => setOpen(false), [loc.pathname]);

  return (
    <header className="sticky top-0 z-50 w-full border-b border-border" style={{ background: "rgba(255,255,255,0.88)", backdropFilter: "blur(12px)" }}>
      <div className="container-atk flex items-center justify-between h-16 lg:h-[72px]">
        <Link to="/" className="flex items-center gap-2.5" aria-label="AutomationTK home">
          <img src={logoColor} alt="AutomationTK logo" width={38} height={38} className="h-8 lg:h-[38px] w-auto" />
          <span className="font-extrabold text-navy text-lg lg:text-xl tracking-tight">AutomationTK</span>
        </Link>

        <nav className="hidden lg:flex items-center gap-1" aria-label="Primary">
          {NAV.map((n) => (
            <NavLink
              key={n.to}
              to={n.to}
              className={({ isActive }) =>
                `px-3 py-2 text-[15px] font-medium rounded-full transition-colors ${
                  isActive && !n.to.includes("#") ? "text-primary" : "text-navy/80 hover:text-primary"
                }`
              }
            >
              {n.label}
            </NavLink>
          ))}
          <Button asChild size="lg" className="ml-3 rounded-full h-12 px-6 font-semibold" data-cta="book-workflow-diagnosis" onClick={() => track("cta_header_book_click")}>
            <Link to="/book">Book a workflow diagnosis <ArrowRight className="ml-1 h-4 w-4" /></Link>
          </Button>
        </nav>

        <Sheet open={open} onOpenChange={setOpen}>
          <SheetTrigger asChild className="lg:hidden">
            <button aria-label="Open menu" className="p-2 -mr-2 text-navy">
              {open ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
            </button>
          </SheetTrigger>
          <SheetContent side="right" className="w-full sm:max-w-sm">
            <SheetTitle className="sr-only">Menu</SheetTitle>
            <Button asChild size="lg" className="mt-8 rounded-full h-12 font-semibold w-full" data-cta="book-workflow-diagnosis">
              <Link to="/book" onClick={() => track("cta_header_book_click")}>Book a workflow diagnosis</Link>
            </Button>
            <nav className="flex flex-col gap-1 mt-6" aria-label="Mobile">
              {NAV.map((n) => (
                <Link key={n.to} to={n.to} className="px-3 py-3 text-lg font-semibold text-navy hover:text-primary border-b border-border">
                  {n.label}
                </Link>
              ))}
            </nav>
          </SheetContent>
        </Sheet>
      </div>
    </header>
  );
}
